<app-sidenav>
  <div class="container-fluid p-5">
    <div class="title">
      <div class="subtitle">
        <i class="fas fa-building icon"></i>
        <div class="subtitleText">
          <span>{{exibirRepresentantes ? 'SOLICITAR GARANTIA' : 'CORRIGIR DADOS BANCÁRIOS'}}</span>
          <span class="nomeIF">{{dadoInstituicao.nomeInstituicao}}</span>
        </div>
      </div>
      <span> Liquidou em {{dadoInstituicao.dataLiquidacao | date:"dd/MM/yyyy"}} </span>
    </div>
    <div class="row col-12 ">
      <form class="col-12 p-5" >
        <div class="bullet-title">
          <span>1</span>
          <h3>Dados de Depósito</h3>
        </div>
              <div class="form-row mt-4 d-flex justify-content-center">
                <div class="form-group col-8">
                  <form [formGroup]="formPagamentoOnline">
                    <div class="custom-box mt-4 p-5">
                      <div class="col-12 text-center">
                        <h2 class="custom-box-title">Dados Bancários para Depósito</h2>
                      </div>
                      <div class="col-12 text-center">
                        <p class="custom-box-subtitle">
                          Para receber o pagamento da garantia, a conta deve estar vinculada ao CNPJ do credor (Pessoa Jurídica). Selecione os dados bancários para prosseguir.
                        </p>
                      </div>
                      <div class="form-row mt-3">
                        <div class="form-group col-12">
                          <label class="form-label" >Banco para depósito <b class="text-danger">*</b></label>
                          <select data-testid="banco-deposito-solicitacao" type="text" name="bancoId" formControlName="bancoId"
                            class="form-control form-adaptable form-icon-trailing">
                            <option *ngFor="let opt of arrayBancos" [value]="opt.id">{{opt.nome}}</option>
                          </select>
                          <div *ngIf="bancoId.touched && bancoId.invalid" class="text-danger">
                            Selecione um Banco.
                          </div>
                        </div>
                      </div>
                      <div class="form-row mt-3">
                        <div class="form-group col-3">
                          <label class="form-label" >Tipo de conta <b class="text-danger">*</b></label>
                              <select data-testid="tipo-conta-solicitacao" type="text" name="tipoConta" formControlName="tipoContaPagamento"
                              class="form-control form-adaptable form-icon-trailing">
                              <option value="Poupança">Conta Poupança</option>
                              <option value="Conta Corrente">Conta Corrente</option>
                            </select>
                            <div *ngIf="tipoContaPagamento.touched && tipoContaPagamento.invalid" class="alert alert-danger">
                              <span class="error-form ml-2" *ngIf="tipoContaPagamento.invalid && (tipoContaPagamento.dirty || tipoContaPagamento.touched)">Campo obrigatório.</span>
                              <!-- <div *ngIf="confirmaEmail.errors.email">O email informado não é válido.</div> -->
                            </div>
                        </div>
                        <div class="form-group col-3">
                          <label class="form-label" >Agência <b class="text-danger">*</b></label>
                          <input
                          data-testid="agencia-solicitar-garantia"
                          type="text"
                          autocomplete="off"
                          name="agenciaPagamento"
                          formControlName="agenciaPagamento"
                          class="form-control form-adaptable form-icon-trailing"
                          inputmode="numeric"
                          mask="0000"
                          placeholder="0000"/>
                            <div *ngIf="agenciaPagamento.touched && agenciaPagamento.invalid" class="alert alert-danger">
                              <span class="error-form ml-2" *ngIf="agenciaPagamento.invalid && (agenciaPagamento.dirty || agenciaPagamento.touched)">Campo obrigatório.</span>
                            </div>
                        </div>
                        <div class="form-group col-3" *ngIf="this.bancoId.value == '001'">
                          <label class="form-label" >Dígito Agência <b class="text-danger">*</b></label>
                          <input
                            data-testid="digito-agencia-solicitacao"
                            type="text"
                            autocomplete="off"
                            class="form-control form-adaptable"
                            name="digitoAgencia"
                            formControlName="digitoAgencia"
                            maxlength="1"
                            (input)="validateDataBank($event)"/>
                              <div *ngIf="digitoAgencia.touched && digitoAgencia.invalid" class="alert alert-danger">
                                <span class="error-form ml-2" *ngIf="digitoAgencia.invalid && (digitoAgencia.dirty || digitoAgencia.touched)">Campo obrigatório.</span>
                              </div>
                        </div>
                        <div class="form-group col-3">
                          <label class="form-label" >Conta <b class="text-danger">* </b>
                            <i
                              class="fas fa-info-circle"
                              mdbTooltip="Informe a conta sem o dígito"
                              placement="top">
                            </i>
                          </label>
                          <input
                            data-testid="conta-solicitacao"
                            type="text"
                            autocomplete="off"
                            name="contaPagamento"
                            formControlName="contaPagamento"
                            class="form-control form-adaptable form-icon-trailing"
                            maxlength="12"
                            placeholder="00000000"
                            (input)="validateDataBank($event)"/>
                              <div *ngIf="contaPagamento.touched && contaPagamento.invalid" class="alert alert-danger">
                                <span class="error-form ml-2" *ngIf="contaPagamento.invalid && (contaPagamento.dirty || contaPagamento.touched)">Campo obrigatório.</span>
                                <!-- <div *ngIf="confirmaEmail.errors.email">O email informado não é válido.</div> -->
                              </div>
                        </div>
                        <div class="form-gro up col-3">
                          <label class="form-label" >Digito <b class="text-danger">*</b></label>
                          <input
                            data-testid="digito-conta-solicitacao"
                            type="text"
                            autocomplete="off"
                            name="digitoContaPagamento"
                            formControlName="digitoContaPagamento"
                            class="form-control form-adaptable form-icon-trailing"
                            maxlength="1"
                            placeholder="0"
                            (input)="validateDataBank($event)"/>
                              <div *ngIf="digitoContaPagamento.touched && digitoContaPagamento.invalid" class="alert alert-danger">
                                <span class="error-form ml-2" *ngIf="digitoContaPagamento.invalid && (digitoContaPagamento.dirty || digitoContaPagamento.touched)">Campo obrigatório.</span>
                              </div>
                          </div>
                      </div>

                    </div>
                    <!--  -->
                  </form>
                </div>
              </div>
              <div class="form-row mt-4 d-flex justify-content-center" *ngIf="exibirRepresentantes">
                <div class="bullet-title mt-4">
                  <span>2</span>
                  <h3>Dados dos Representantes</h3>
                </div>
                  <div class="custom-box-alert mt-4">
                    <i class="fas fa-info-circle"></i>
                    <p>O Representante Legal da empresa será responsável por todos os atos em nome da Pessoa Jurídica. É obrigatório o cadastro de ao menos 01 (um) Representante Legal que possui poderes de representação conforme Estatuto ou Contrato Social da empresa.</p>
                  </div>
                <div class="form-group col-8 mt-4">
                  <form [formGroup]="formEmpresa">
                    <div class="custom-box mt-4 p-5">
                      <div class="col-12 text-center">
                        <h2 class="custom-box-title">Editar dados dos Representantes</h2>
                      </div>
                      <div>
                        <div class="col-12 text-center">
                          <p class="custom-box-subtitle">Confirme ou edite os dados dos Representantes Legais da empresa</p>
                        </div>
                      </div>
                      <div class="form-row mt-3 mb-5">
                        <div class="form-group col-6">
                          <label class="form-label" >CNPJ da Empresa</label>
                          <input formControlName="cnpjEmpresa" autocomplete="off" mask="AA.AAA.AAA/AAAA-AA" class="form-control form-adaptable form-icon-trailing"/>
                        </div>
                        <div class="form-group col-6">
                          <label class="form-label" >Nome/Razão Social <b class="text-danger">*</b></label>
                          <input data-testid="razao-social-solicitacao" autocomplete="off-" formControlName="nomeEmpresa" maxlength="150" class="form-control form-adaptable form-icon-trailing" />
                          <span class="error-form ml-2" *ngIf="formEmpresa.get('nomeEmpresa')?.hasError('required') && (formEmpresa.get('nomeEmpresa').dirty || formEmpresa.get('nomeEmpresa').touched)">Campo obrigatório.</span>
                          <span class="error-form ml-2" *ngIf="formEmpresa.get('nomeEmpresa')?.hasError('pattern')">Campo contém caracteres inválidos.</span>
                        </div>
                        <div class="form-group col-6">
                          <span class="info-text"><i class="fas fa-info-circle"></i> Campo não editável</span>
                        </div>
                      </div>
                      <hr>
                      <div formArrayName="representantes">
                        <div class="mt-5" *ngFor="let rep of representantes.controls; let i = index" [formGroupName]="i">
                          <h2 class="title-section"><i class="fas fa-edit"></i>
                             Representante Legal {{ i + 1}}
                             <span class=" badge badge-solid" *ngIf="i === 0">Obrigatório</span>
                             <span class=" badge badge-outline" *ngIf="i === 1">Se aplicável</span>
                            </h2>
                          <p class="subtitle-section">Pessoa com poderes de assinar em nome da empresa</p>
                          <div class="form-row mt-3">
                            <div class="form-group col-12">
                              <label class="form-label" >Nome Completo <b class="text-danger" *ngIf="i === 0">*</b></label>
                              <input data-testid="nome-representante-solicitacao" autocomplete="off-" formControlName="nome" maxlength="150" placeholder="Nome Completo" class="form-control form-adaptable form-icon-trailing" />
                              <span class="error-form ml-2" *ngIf="rep.get('nome').hasError('required') && (rep.get('nome').dirty || rep.get('nome').touched)">Campo obrigatório.</span>

                            </div>
                            <div class="form-group col-6">
                              <label class="form-label" >CPF <b class="text-danger" *ngIf="i === 0">*</b></label>
                              <input data-testid="cpf-representante-solicitacao" autocomplete="off" formControlName="cpf" placeholder="000.000.000-00" mask="000.000.000-00" class="form-control form-adaptable form-icon-trailing" />
                              <span class="error-form ml-2" *ngIf="rep.get('cpf').hasError('required') && (rep.get('cpf').dirty || rep.get('cpf').touched)">Campo obrigatório.</span>
                            </div>
                            <div class="form-group col-6">
                              <label class="form-label" >E-mail <b class="text-danger" *ngIf="i === 0">*</b></label>
                              <input data-testid="email-representante-solicitacao" autocomplete="off-" formControlName="emailPj" placeholder="exemplo@exemplo.com" class="form-control form-adaptable form-icon-trailing" />
                              <span class="error-form ml-2" *ngIf="rep.get('emailPj').hasError('required') && (rep.get('emailPj').dirty || rep.get('emailPj').touched)">Campo obrigatório.</span>
                              <span class="error-form ml-2" *ngIf="rep.get('emailPj')?.hasError('emailInvalid') && rep.get('emailPj')?.dirty">E-mail inválido.</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div *ngIf="editaRepresentantes === false" class="col-12 text-center">
                          <p class="custom-box-subtitle">
                            Já existe um <b>pedido de garantia</b> para esta empresa em fase de validação. Por esse motivo, <b>a edição de representantes não é permitida neste momento</b>. Serão consideradas as <b>mesmas informações já informadas</b>.
                          </p>
                        </div>
                      </div>


                    </div>
                  </form>
                </div>
              </div>

              <div class="form-row mt-4">
                <div class="form-group col-12 d-flex justify-content-center g-3">
                  <button data-testid="botao-voltar-solicitacao" class="btn voltar mr-4" (click)="previous()">Voltar</button>
                  <button data-testid="botao-continuar-solicitacao" class="btn continuar" (click)="enviarForm()">Continuar</button>
                </div>
              </div>

            </form>

          </div>
  </div>
</app-sidenav>
